/** 사이트 전역 상수. 푸터·메타 등에서 공유한다. */
export const SITE = {
    name: 'HACCP AI',
    org: '퍼블릭에이아이(PublicAI)',
    orgUrl: 'https://www.publicai.co.kr',
    // 공식 창구(외부) 링크.
    haccpUrl: 'https://www.haccp.or.kr',
    foodSafetyUrl: 'https://www.foodsafetykorea.go.kr',
} as const
